// extracted by mini-css-extract-plugin
export default {"shell":"ForestBackdrop_shell__jgBsV","content":"ForestBackdrop_content__V-1R5"};